import * as actionTypes from "../constants/actionTypes";
import * as componentTypes from "../constants/componentTypes";
import * as config from "../constants/config";
import * as orderBy from "../constants/orderBy";

/**
 * Structure of object from statistics store:
 * - formulaList {Array}        - list of statistics
 * - sortingCriterion {String}  - column name asi criterion for sorting
 * - sortingAsc {Boolean}       - sorting in ascending or descending order
 * - filter {String}            - text used for table filtering
 * - offset {Number}            - number of loaded items used for server reloading on scroll
 * - showHidden {Boolean}       - shows hidden records
 * - correctionHistory {Array}  - history of corrections
 */

const initialState = {
    formulaList: [],
    sortingCriterion: orderBy.TIMESTAMP,
    sortingAsc: false,
    filter: null,
    offset: 0,
    showHidden: false,
    correctionHistory: null
};

export const statisticsTabReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STATISTICS_TAB_SAVE_FORMULA_LIST:
            return {
                ...state,
                formulaList: action.payload.formulaList,
                offset: config.MAX_STATISTICS_LIMIT
            };
        case actionTypes.SAVE_CORRECTION_HISTORY:
            return {
                ...state,
                correctionHistory: action.payload.correctionHistory
            };
        case actionTypes.STATISTICS_TAB_SAVE_FORMULA_LIST_WITH_OFFSET:
            return {
                ...state,
                formulaList: state.formulaList.concat(action.payload.formulaList)
            };
        case actionTypes.STATISTICS_LIST_UPDATE:
            return {
                ...state,
                formulaList: [],
                offset: 0
            };
        case actionTypes.STATISTICS_TAB_SAVE_SORTING:
            return {
                ...state,
                formulaList: [],
                sortingCriterion: action.payload.criterion,
                sortingAsc: action.payload.asc,
                offset: 0
            };
        case actionTypes.STATISTICS_SAVE_FILTER:
            return {
                ...state,
                formulaList: [],
                filter: action.payload.filter,
                offset: 0
            };
        case actionTypes.STATISTICS_CHANGE_OFFSET:
            return {
                ...state,
                offset: action.payload.offset
            };
        case actionTypes.STATISTICS_SET_SHOW_HIDDEN:
            return {
                ...state,
                formulaList: [],
                offset: 0,
                showHidden: action.payload.showHidden
            };
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
            let tab;
            for (tab of action.payload.newTabList) {
                if (tab.type === componentTypes.STATISTICS_TAB) {
                    return state;
                }
            }

            return initialState;
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return initialState;
        default:
            return state;
    }
};
